import VueI18n from 'vue-i18n';

export interface User {
  id?: number,
  user_id?: number, // It's when user in same model with other data
  photo?: string,
  phone?: string,
  name?: string,
  user_name?: string,
  last_name?: string,
  user_last_name?: string,
}

export class UserModel implements User {
  id?: number;
  last_name?: string;
  name?: string;
  phone?: string;
  photo?: string;

  constructor (data: User) {
    if (data) {
      this.id = data.user_id || data.id;
      this.last_name = data.user_last_name || data.last_name;
      this.name = data.user_name || data.name;
      this.phone = data.phone;
      this.photo = data.photo;
    }
  }

  get getFullName () {
    return `${this.name || ''} ${this.last_name || ''}`;
  }

  get getPhoto () {
    if (this.photo) {
      return process.env.VUE_APP_IMAGE_SERVER + '/' + this.photo;
    } else {
      return require('@/assets/img/background-image-small.webp');
    }
  }

  get getNameOrApp () {
    return this.photo ? this.getFullName : (new VueI18n()).t('app_name');
  }
}
